import { render, staticRenderFns } from "./QueryLogManage.vue?vue&type=template&id=35ddeacc&scoped=true"
import script from "./QueryLogManage.vue?vue&type=script&lang=js"
export * from "./QueryLogManage.vue?vue&type=script&lang=js"
import style0 from "./QueryLogManage.vue?vue&type=style&index=0&id=35ddeacc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35ddeacc",
  null
  
)

export default component.exports